var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatsUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.584 21.886H2.11402V1.416C2.11402 1.02956 1.80479 0.694003 1.39202 0.694003C0.976895 0.694003 0.694019 1.03203 0.694019 1.416V23.256V23.306H0.744019H22.584C22.9705 23.306 23.306 22.9968 23.306 22.584C23.306 22.1689 22.968 21.886 22.584 21.886Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.248 17.234H10.2687L10.2833 17.2193L13.2687 14.234H18.624H18.6447L18.6593 14.2194L21.502 11.3767V14.232C21.502 14.6184 21.8112 14.954 22.224 14.954C22.6356 14.954 22.946 14.6436 22.946 14.232V9.936C22.946 9.28506 22.4203 8.734 21.744 8.734H17.52C17.1335 8.734 16.798 9.04323 16.798 9.456C16.798 9.86761 17.1084 10.178 17.52 10.178H20.7113L18.0753 12.814H12.72H12.6993L12.6846 12.8286L9.69928 15.814H5.13599C4.74955 15.814 4.41399 16.1232 4.41399 16.536C4.41399 16.9511 4.75202 17.234 5.13599 17.234H10.248Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsUp);
export default __webpack_public_path__ + "static/media/stats-up.19087822.svg";
export { ForwardRef as ReactComponent };